import React, { useEffect, useState } from "react";
import { Row, Col, Form, Select, Input, message } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { getAllcategories } from "../../../utils/API";
import { useNavigate } from "react-router-dom";
import statesData from "./states.json";
import image1 from "../../../assets/frontendassets/websiteimages/banner.png";
import "./Homepage.css";
import { FaInstagram, FaInstagramSquare, FaLinkedin } from "react-icons/fa";
import { AiFillFacebook } from "react-icons/ai";
import { FaSquareXTwitter } from "react-icons/fa6";
import countriesData from "../../../utils/countries.json";
import { detectCountryCode, detectCountryCodeForHome } from "../../../utils/setting";

interface StateOption {
  label: string;
  value: string;
}

const HomeBanner = () => {
  const [categories, setCategories] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const [selectedState, setSelectedState] = useState<string | null>(null);
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [states, setStates] = useState<{ code: string; country: string }[]>([]);
  const navigate = useNavigate();


    useEffect(() => {
      const fetchCountryCode = async () => {
        const countryName = await detectCountryCodeForHome(); // Get country name
        setSelectedCountry(countryName);
        console.log("Detected Country:", countryName);
  
        // Find states for the detected country
        const country = countriesData.countries.find((c) => c.country === countryName);
        if (country) {
          setStates(country.states); // Set available states
          if (country.states.length > 0) {
            setSelectedState(country.states[0].country); // Auto-select first state
          }
        }
      };
  
      fetchCountryCode();
    }, []);

  const fetchCategories = async () => {
    setLoading(true);
    try {
      const response = await getAllcategories();
      const filteredCategories = response.filter(
        (category: any) =>  !category.categoryId && !category.isDeleted 
      );
      setCategories(filteredCategories);
    } catch (error) {
      message.error("Network error. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  const handleSearch = () => {
    navigate(`/listing?category=${selectedCategory || ''}&state=${selectedState || ''}&country=${selectedCountry || ''}`);
  };

  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selected = e.target.value;
    setSelectedCountry(selected);
    setSelectedState(null); // Reset state when country changes

    const country = countriesData.countries.find((c) => c.country === selected);
    setStates(country ? country.states : []);
  };

  return (
    <>
     <div
  className="flex flex-col xl:flex-row items-center xl:justify-between pt-24 sm:pt-24 sm:pb-24 md:pt-24 md:pb-4 xl:pt-36 xl:px-36 xl:pb-8 bg-[#FFF8EC] relative"
  style={{
    backgroundImage: `url(${image1})`,
    // opacity: "0.9",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    objectFit: "cover",
    backgroundPosition: "center top 150px",
  }}
>
  {/* Centered Content */}
  <div

      >
        <div className="w-full p-6 text-center flex flex-col justify-center items-center">
          <h1 className="text-[30px] sm:text-[40px] md:text-[50px] font-medium text-black mb-4">
            Welcome to Net4Surge
          </h1>
          <h2 className="text-[24px] sm:text-[30px] md:text-[40px] text-black mb-6">
            Your Premier Business Listing Platform
          </h2>
          <p className="text-black mb-8 text-[16px] sm:text-[18px] md:text-[22px]">
            We believe in the power of Visibility and Connectivity. Our platform is designed to connect businesses globally with their ideal customers by providing comprehensive, accurate, and up-to-date business listings.
          </p>

          <Form className="flex flex-col sm:flex-row items-center flex-wrap justify-between gap-4 sm:gap-0 bg-[#F9B138] p-4">
            <p className="text-gray-800 lg:text-[15px] md:text-[12px] text-[20px] text-center flex-shrink-0" style={{ flex: "1 1 0" }}>
              What are you looking for?
            </p>

            <div className="h-10 sm:block hidden border-l-2 border-gray-800"></div>

            {/* Category Selector */}
            <div className="flex items-center px-4 w-full sm:w-auto" style={{ flex: "1 1 0" }}>
              <select
                className="bg-transparent lg:text-[15px] md:text-[12px] text-[20px] text-gray-800 px-2 appearance-none outline-none border-none w-full truncate"
                onChange={(e) => setSelectedCategory(e.target.value)}
              >
                <option value="" className="lg:text-[15px] md:text-[12px] text-[20px]">All Categories</option>
                {categories.map((category) => (
                  <option key={category._id} value={category._id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="h-10 sm:block hidden border-l-2 border-gray-800"></div>

            {/* Country Selector */}
            <div className="flex items-center px-4 w-full sm:w-auto" style={{ flex: "1 1 0" }}>
              <select
                className="bg-transparent text-gray-800 lg:text-[15px] md:text-[12px] text-[20px] px-2 appearance-none outline-none border-none w-full truncate"
                onChange={handleCountryChange}
                value={selectedCountry || ""}
              >
                <option value="" className="lg:text-[15px] md:text-[12px] text-[20px]">Select Country</option>
                {countriesData.countries.map((country) => (
                  <option key={country.code} value={country.country}>
                    {country.country}
                  </option>
                ))}
              </select>
            </div>

            <div className="h-10 sm:block hidden border-l-2 border-gray-800"></div>

            {/* State Selector (Dependent on Country) */}
            <div className="flex items-center px-4 w-full sm:w-auto" style={{ flex: "1 1 0" }}>
              <select
                className="bg-transparent text-gray-800 lg:text-[15px] md:text-[12px] text-[20px] px-2 appearance-none outline-none border-none w-full truncate"
                onChange={(e) => setSelectedState(e.target.value)}
                value={selectedState || ""}
                disabled={!selectedCountry}
              >
                <option value="" className="lg:text-[15px] md:text-[12px] text-[20px]">Select State</option>
                {states.map((state) => (
                  <option key={state.code} value={state.country}>
                    {state.country}
                  </option>
                ))}
              </select>
            </div>

            {/* Search Button */}
            <button
              className="bg-[#FFF1D0] text-black font-normal rounded-lg h-10 px-4 py-2 hover:bg-white flex-shrink-0"
              onClick={handleSearch}
            >
              <SearchOutlined className="mr-2" />
              <span>Search</span>
            </button>
          </Form>
        </div>
      </div>
  {/* Social Media Icons */}
  <div className="absolute top-auto right-8 xl:right-12 flex flex-col gap-3 mt-2">
  <a
    href="https://instagram.com/net4surge" // Replace with your Instagram URL
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaInstagram
      size={40}
      className="text-white p-[2px] hidden lg:block cursor-pointer"
      style={{
        backgroundImage: "linear-gradient(to top right, #feda75, #fa7e1e, #d6249f)",
        borderRadius : "22%",
      }}
    />
  </a>
  <a
    href="https://www.facebook.com/net4surge" // Replace with your Facebook URL
    target="_blank"
    rel="noopener noreferrer"
  >
    <AiFillFacebook
      size={40}
      className="text-blue-500 cursor-pointer hidden lg:block"
    />
  </a>
  <a
    href="https://x.com/net4surge
" // Replace with your Twitter URL
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaSquareXTwitter
      size={40}
      className="bg-white cursor-pointer hidden lg:block"
    />
  </a>
  {/* Uncomment and update if needed */}
  {/* <a
    href="https://www.linkedin.com/in/yourprofile" // Replace with your LinkedIn URL
    target="_blank"
    rel="noopener noreferrer"
  >
    <FaLinkedin size={40} className="text-blue-600 cursor-pointer" />
  </a> */}
</div>

</div>


      {/* Stats Section */}
      <div className="mt-0 md:mt-0 lg:mt-0 sm:mt-0 bg-[#FFF8EC]">
  <Row
    justify="space-between"
    className="px-8 sm:px-12 md:px-12 bg-[#FFF8EC] flex-wrap"
    align="middle"
  >
    <Col xs={12} sm={12} md={6} xl={6} xxl={6} className="text-center p-3 sm:p-6">
      <p className="text-3xl md:text:[26px] lg:text-[38px] xl:text-[55px] font-bold text-black">200+</p>
      <p className="text-[#FFB800] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[30px] asasaas pt-4 pb-3 sm:text-[25px]">
        Awards Won
      </p>
      <p className="text-[14px] sm:text-[16px] md:text-[20px]">
        Recognized for excellence and innovation.
      </p>
    </Col>
    <Col xs={12} sm={12} md={6} xl={6} xxl={6} className="text-center p-3 sm:p-6">
      <p className="text-3xl md:text:[26px] lg:text-[38px] xl:text-[55px] font-bold text-black">76k</p>
      <p className="text-[#FFB800] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[30px] asasaas pt-4 pb-3 sm:text-[25px]">
        Approved Listing
      </p>
      <p className="text-[14px] sm:text-[16px] md:text-[20px]">
        Verified and trusted by thousands.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </p>
    </Col>
    <Col xs={12} sm={12} md={6} xl={6} xxl={6} className="text-center p-3 sm:p-6">
      <p className="text-3xl md:text:[26px] lg:text-[38px] xl:text-[55px] font-bold text-black">400+</p>
      <p className="text-[#FFB800] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[30px] asasaas pt-4 pb-3 sm:text-[25px]">
        Expert People
      </p>
      <p className="text-[14px] sm:text-[16px] md:text-[20px]">
        Highly skilled professionals at your service.
      </p>
    </Col>
    <Col xs={12} sm={12} md={6} xl={6} xxl={6} className="text-center p-3 sm:p-6">
      <p className="text-3xl md:text:[26px] lg:text-[38px] xl:text-[55px] font-bold text-black">40k+</p>
      <p className="text-[#FFB800] md:text-[18px] lg:text-[18px] xl:text-[18px] 2xl:text-[30px] asasaas pt-4 pb-3 sm:text-[25px]">
        Happy Customers
      </p>
      <p className="text-[14px] sm:text-[16px] md:text-[20px]">
        Trusted by thousands and counting.
      </p>
    </Col>
  </Row>
</div>

    </>
  );
};

export default HomeBanner;
